'use client';

import { ProductRating } from '@eliadmin/core/src/components/product/detail/product-rating';
import { Badge } from '@eliadmin/core/src/components/ui/badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { isNullish, youtubeEmbedToNotEmbed } from '@eliadmin/core/src/utils/misc-utils';
import { cn, getContrastYIQ } from '@eliadmin/core/src/utils/style-utils';
import { FaYoutube } from 'react-icons/fa';
import { ProductShortDescription } from './product-short-description';

export function ProductHeader() {
  const { t } = useTranslations();
  const product = useVariantsStore(s => s.product);
  const selectedVariant = useVariantsStore(s => s.selectedVariant);
  const video = product.video;

  const descriptionToRender =
    selectedVariant?.short_description ||
    selectedVariant?.description ||
    product.short_description ||
    product.description;

  return (
    <div className={cn('flex flex-col gap-3', 'ea-product-detail-header')}>
      {/* tags */}
      <div className={cn('flex flex-row gap-2', 'ea-product-detail-header__badge-wrapper')}>
        {product.tags?.map((badge, i) => {
          return (
            <Badge
              key={`tag-${i}`}
              style={{
                backgroundColor: badge.color ?? undefined,
                color: badge.color ? getContrastYIQ(badge.color) : undefined,
              }}
              size="md"
              className={cn('flex flex-row gap-2', 'ea-product-detail-header__badge')}
            >
              {badge.name}
            </Badge>
            // <span
            //   key={`tag-${i}`}
            //   className={'mr-2 rounded-2xl px-2 py-1 text-xs'}
            //   style={{ backgroundColor: badge.color, color: getContrastYIQ(badge.color) }}
            // >
            //   {badge.name}
            // </span>
          );
        })}
      </div>
      {/* title */}
      <h1
        data-ea-primary-heading
        className={cn('mb-0 text-2xl font-bold', 'ea-product-detail-header__title')}
      >
        {selectedVariant?.name || product.name}
      </h1>
      <div className={cn('flex flex-row', 'ea-product-detail-header__content')}>
        {/* rating */}
        {!isNullish(product.rating) && (
          <ProductRating
            className={{
              wrapper: cn('', 'ea-product-detail-header__product-rating-wrapper'),
              starIcon: cn(
                'fill-rating stroke-rating',
                'ea-product-detail-header__product-rating-star-icon',
              ),
              starWrapper: cn('', 'ea-product-detail-header__product-rating-star-wrapper'),
              starDisabled: cn(
                'fill-white stroke-white',
                'ea-product-detail-header__product-rating-star-disabled',
              ),
            }}
            rating={product.rating}
          />
        )}
        {/* video */}
        {video && (
          <Button
            variant="outline"
            className={cn(
              'ml-4 flex h-8 cursor-pointer items-center space-x-1 px-4 py-0',
              isNullish(product.rating) && 'ml-0',
              'ea-product-detail-header__product-video',
            )}
            id="showYtbVideo"
            onClick={() => {
              window.open(youtubeEmbedToNotEmbed(video), '_blank');
            }}
          >
            <FaYoutube
              className={cn(
                'h-[18px] w-[18px] fill-red-500',
                'ea-product-detail-header__product-video-youtube',
              )}
            />
            <p
              className={cn(
                'text-xs font-semibold text-foreground',
                'ea-product-detail-header__product-video-text',
              )}
            >
              {t('text451')}
            </p>
          </Button>
        )}
      </div>
      {/* description */}
      {!!descriptionToRender?.length && (
        <ProductShortDescription
          key={`${product.id}:${selectedVariant?.id ?? 'product'}:${descriptionToRender}`}
          html={descriptionToRender}
        />
      )}
    </div>
  );
}
